<template>
    <div class="row full">
        <!-- Sidebar toggle -->
        <div v-if="sidebarCollapsed" class="sidebar-toggle sidebar-toggle-left" @click="sidebarCollapsed = false" title="展开菜单">▶</div>

        <!-- Left tab buttons -->
        <div class="column sidebar" :style="{ width: sidebarCollapsed ? '0px' : '100px', minWidth: sidebarCollapsed ? '0px' : '100px', flexShrink: sidebarCollapsed ? '' : '0', overflow: sidebarCollapsed ? 'hidden' : '' }">
            <div class="sidebar-collapse-btn" @click="sidebarCollapsed = true" title="收起菜单">◀</div>
            <SerialConnector
                @connected="onSerialConnected"
                @disconnected="onSerialDisconnected"
            />
            <button class="tab-btn" :class="activeTab=='edgefind'? 'active': ''" @click="activeTab='edgefind'">
                <span class="tab-icon">🧭</span>
                <span class="tab-label">寻边</span>
            </button>
            <button class="tab-btn" :class="activeTab=='measure2'? 'active': ''" @click="activeTab='measure2'">
                <span class="tab-icon">📏</span>
                <span class="tab-label">两点测量</span>
            </button>
            <div class="column gap10" style="flex:1; overflow-y:auto;">
                <button class="tab-btn" :class="activeTab=='align'? 'active': ''" @click="activeTab='align'">
                    <span class="tab-icon">📐</span>
                    <span class="tab-label">对齐/分中</span>
                </button>
            <button class="tab-btn" :class="activeTab=='topface'? 'active': ''" @click="activeTab='topface'">
                <span class="tab-icon">🔲</span>
                <span class="tab-label">顶面铣</span>
            </button>
            <button class="tab-btn" :class="activeTab=='millside'? 'active': ''" @click="activeTab='millside'">
                <span class="tab-icon">🪚</span>
                <span class="tab-label">侧面铣</span>
            </button>
            <button class="tab-btn" :class="activeTab=='5mill'? 'active': ''" @click="activeTab='5mill'">
                <span class="tab-icon">⚙️</span>
                <span class="tab-label">5面铣</span>
            </button>
            <button class="tab-btn" :class="activeTab=='threadmill'? 'active': ''" @click="activeTab='threadmill'">
                <span class="tab-icon">🔧</span>
                <span class="tab-label">螺纹铣</span>
            </button>
            <button class="tab-btn" :class="activeTab=='drill'? 'active': ''" @click="activeTab='drill'">
                <span class="tab-icon">🔩</span>
                <span class="tab-label">钻孔</span>
            </button>
            <button class="tab-btn" :class="activeTab=='vcut'? 'active': ''" @click="activeTab='vcut'">
                <span class="tab-icon">✂️</span>
                <span class="tab-label">PCB V割</span>
            </button>
            </div>
        </div>

        <!-- Center content area -->
        <div class="grow" :style="{ marginLeft: sidebarCollapsed ? '4px' : '20px', overflow: 'auto' }">
            <Align v-show="activeTab=='align'"></Align>
            <VCut v-show="activeTab=='vcut'"></VCut>
            <MillTopFace v-show="activeTab=='topface'"></MillTopFace>
            <Drill v-show="activeTab=='drill'"></Drill>
            <Mill5Face v-show="activeTab=='5mill'"></Mill5Face>
            <MillSide v-show="activeTab=='millside'"></MillSide>
            <EdgeFind v-show="activeTab=='edgefind'"></EdgeFind>
            <Measure2Point v-show="activeTab=='measure2'"></Measure2Point>
            <MillThread v-show="activeTab=='threadmill'"></MillThread>
        </div>

        <!-- Resize handle -->
        <div
            v-show="!filePanelCollapsed"
            class="resize-handle"
            :class="{ 'resize-active': isResizing }"
            @mousedown="startResize"
        ></div>

        <!-- Collapse/expand toggle -->
        <div class="panel-toggle" @click="filePanelCollapsed = !filePanelCollapsed" :title="filePanelCollapsed ? '展开文件面板' : '收起文件面板'">
            <span v-if="filePanelCollapsed">◀</span>
            <span v-else>▶</span>
        </div>

        <!-- Right file panel -->
        <div class="column file-panel" :style="{ width: filePanelCollapsed ? '0px' : (filePanelWidth + 'px'), minWidth: filePanelCollapsed ? '0px' : '400px', overflow: filePanelCollapsed ? 'hidden' : '' }">
            <!-- Tab bar -->
            <div class="file-tab-bar">
                <div class="file-tab-list">
                    <div
                        v-for="(tab, idx) in fileTabs"
                        :key="idx"
                        class="file-tab"
                        :class="{ active: idx === activeFileIdx }"
                        :title="tab.name"
                        @click="activeFileIdx = idx"
                    >
                        <span class="file-tab-name">{{ tab.name }}</span>
                        <span class="file-tab-close" @click.stop="closeFileTab(idx)">&times;</span>
                    </div>
                </div>
                <div class="file-tab-actions">
                    <button class="icon-btn" @click="copyActiveFile" title="复制内容">📋</button>
                    <button class="icon-btn" @click="previewActiveFile" title="在 NC Viewer 中预览">🔍</button>
                    <button class="icon-btn" @click="triggerUpload" title="上传NC文件">📂</button>
                    <button class="icon-btn" @click="downloadActiveFile" title="下载当前文件">📥</button>
                </div>
            </div>

            <!-- File content area -->
            <div class="grow file-content-area">
                <textarea
                    v-if="activeFileIdx >= 0 && fileTabs[activeFileIdx]"
                    class="file-content"
                    v-model="fileTabs[activeFileIdx].content"
                    spellcheck="false"
                ></textarea>
                <div v-else class="file-placeholder">
                    <div>暂无文件</div>
                    <div style="font-size:12px;color:#999;margin-top:8px;">五面铣、钻孔等功能生成的NC<br>将显示在此处</div>
                </div>
            </div>

            <!-- Bottom bar: encoding selector -->
            <div class="file-bottom-bar">
                <div class="bom-indicator" v-if="activeFile && activeFile._bomDetected">
                    BOM: {{ activeFile._bomDetected }}
                </div>
                <div class="grow"></div>
                <label class="encoding-label">
                    编码:
                    <select v-model="encoding" class="encoding-select" @change="onEncodingChange">
                        <option value="gbk">GBK (系统默认)</option>
                        <option value="utf-8">UTF-8</option>
                    </select>
                </label>
            </div>

            <!-- Hidden file input for upload -->
            <input
                type="file"
                ref="panelFileInput"
                style="display:none"
                accept=".nc,.txt,.cnc,.gcode,.tap"
                @change="onPanelFileUpload"
            />
        </div>
    </div>
</template>


<style>
html, body, #app {
    height: 100%;
    margin: 0;
    overflow: hidden;
}

/* ============================================================
   Sidebar container
   ============================================================ */
.sidebar {
    background: #f0f2f4;
    border-right: 1px solid #d5d8da;
    position: relative;
}

.sidebar-collapse-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    width: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #e0e0e0;
    color: #666;
    font-size: 10px;
    user-select: none;
    border-radius: 4px 0 0 4px;
    border: 1px solid #ccc;
    border-right: none;
    transition: background-color 0.15s;
}
.sidebar-collapse-btn:hover {
    background: #ccc;
    color: #333;
}

.sidebar-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    flex-shrink: 0;
    cursor: pointer;
    background: #e0e0e0;
    color: #666;
    font-size: 10px;
    user-select: none;
    transition: background-color 0.15s;
}
.sidebar-toggle:hover {
    background: #ccc;
    color: #333;
}
.sidebar-toggle-left {
    border-right: 1px solid #ccc;
    border-radius: 0 4px 4px 0;
}

/* ============================================================
   Tab button -- base / default state
   ============================================================ */
.tab-btn {
    /* Layout */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    height: 60px;
    padding: 8px 6px 8px 10px;

    /* Appearance */
    border: none;
    border-left: 4px solid transparent;
    border-radius: 0 6px 6px 0;
    background: transparent;
    color: #5a5a5a;

    /* Typography */
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                 "Microsoft YaHei", "PingFang SC", sans-serif;
    font-size: 13px;
    line-height: 1.2;
    text-align: center;
    white-space: nowrap;

    /* Interaction */
    cursor: pointer;
    user-select: none;
    outline: none;

    /* Transition */
    transition:
        background-color 0.20s ease,
        color            0.20s ease,
        border-left-color 0.20s ease,
        box-shadow        0.20s ease;
}

.tab-btn:focus-visible {
    outline: 2px solid cadetblue;
    outline-offset: -2px;
}

/* ============================================================
   Tab icon
   ============================================================ */
.tab-icon {
    font-size: 20px;
    line-height: 1;
}

/* ============================================================
   Tab label (Chinese text)
   ============================================================ */
.tab-label {
    font-size: 12px;
    line-height: 1.2;
    letter-spacing: 0.02em;
}

/* ============================================================
   Hover state
   ============================================================ */
.tab-btn:hover {
    background: #e2e6e9;
    border-left-color: #9cc4c6;
}

/* ============================================================
   Active / selected state
   ============================================================ */
.tab-btn.active {
    background: cadetblue;
    color: #ffffff;
    border-left-color: #3a7a7c;
    box-shadow:
        0 2px 6px rgba(95, 158, 160, 0.30),
        inset 0 1px 0 rgba(255, 255, 255, 0.15);
    font-weight: 600;
}

/* ============================================================
   Active state hover
   ============================================================ */
.tab-btn.active:hover {
    background: #559091;
    border-left-color: #2f6365;
    box-shadow:
        0 1px 3px rgba(95, 158, 160, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.10);
}

/* ============================================================
   SerialConnector integration in sidebar
   ============================================================ */
.sidebar > .serial-connector {
    background: #e8ecee;
    border-bottom: 1px solid #d0d4d7;
}

/* Resize handle */
.resize-handle {
    width: 4px;
    cursor: col-resize;
    background-color: #ddd;
    flex-shrink: 0;
    transition: background-color 0.15s;
}
.resize-handle:hover,
.resize-handle.resize-active {
    background-color: #888;
}

.panel-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    flex-shrink: 0;
    cursor: pointer;
    background: #e0e0e0;
    color: #666;
    font-size: 10px;
    user-select: none;
    transition: background-color 0.15s;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}
.panel-toggle:hover {
    background: #ccc;
    color: #333;
}

/* File panel */
.file-panel {
    min-width: 400px;
    flex-shrink: 0;
    border-left: 1px solid #ccc;
    background: #fafafa;
}

.file-tab-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    background: #e8e8e8;
    border-bottom: 1px solid #ccc;
    flex-shrink: 0;
}

.file-tab-list {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    overflow-x: auto;
    overflow-y: hidden;
    min-width: 0;
    height: 100%;
}
/* Hide scrollbar for tab list (optional, keep functionality) */
.file-tab-list::-webkit-scrollbar {
    height: 3px;
}
.file-tab-list::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 2px;
}

.file-tab {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 100%;
    cursor: pointer;
    white-space: nowrap;
    border-right: 1px solid #ccc;
    background: #e0e0e0;
    font-size: 12px;
    flex-shrink: 0;
    user-select: none;
}
.file-tab:hover {
    background: #d5d5d5;
}
.file-tab.active {
    background: #fafafa;
    border-bottom: 2px solid cadetblue;
}

.file-tab-name {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-tab-close {
    margin-left: 6px;
    font-size: 14px;
    line-height: 1;
    color: #888;
    cursor: pointer;
    padding: 0 2px;
}
.file-tab-close:hover {
    color: #e00;
    background: #ddd;
    border-radius: 2px;
}

.file-tab-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    padding: 0 4px;
    gap: 2px;
}

.icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 2px 6px;
    line-height: 1;
    border-radius: 3px;
}
.icon-btn:hover {
    background: #d0d0d0;
}

.file-content-area {
    overflow: hidden;
    min-height: 0;
}

.file-content {
    width: 100%;
    height: 100%;
    border: none;
    resize: none;
    padding: 8px;
    font-family: 'Consolas', 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.4;
    background: #fafafa;
    color: #333;
    outline: none;
    box-sizing: border-box;
}

.file-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #bbb;
    font-size: 14px;
    user-select: none;
}

/* Bottom bar */
.file-bottom-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 28px;
    padding: 0 8px;
    background: #e8e8e8;
    border-top: 1px solid #ccc;
    flex-shrink: 0;
    font-size: 12px;
}

.bom-indicator {
    color: #888;
    font-size: 11px;
    margin-right: 8px;
}

.encoding-label {
    color: #555;
    font-size: 12px;
    white-space: nowrap;
}

.encoding-select {
    font-size: 12px;
    padding: 1px 4px;
    border: 1px solid #bbb;
    border-radius: 2px;
    background: #fff;
    cursor: pointer;
}

/* Shared fieldset layout (used by all tab pages) */
.param-row {
    display: flex;
    align-items: center;
    margin: 4px 0;
    gap: 6px;
}
.param-row label {
    width: 130px;
    text-align: right;
    font-size: 13px;
}
.hint {
    font-size: 12px;
    color: #888;
}
fieldset {
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px 12px;
}
fieldset legend {
    font-weight: bold;
    color: #555;
}
.desc {
    font-size: 12px;
    color: #666;
    margin: 4px 0 8px 0;
}
</style>


<script>
import { ref, reactive, computed, provide } from "vue";
import {
    readFileAsArrayBuffer,
    decodeBuffer,
    detectBOM,
    downloadTextFile,
} from "../util/browser-fs.js";
import VCut from "./VCut.vue";
import Align from "./Align.vue";
import Mill5Face from "./Mill5Face.vue";
import MillSide from "./MillSide.vue";
import MillTopFace from "./MillTopFace.vue";
import Drill from "./Drill.vue";
import EdgeFind from "./EdgeFind.vue";
import Measure2Point from "./Measure2Point.vue";
import MillThread from "./MillThread.vue";
import SerialConnector from "./SerialConnector.vue";

export default {
    name: "App",
    components: { VCut, Align, MillTopFace, Mill5Face, MillSide, MillThread, Drill, EdgeFind, Measure2Point, SerialConnector },

    setup() {
        const activeTab = ref("align");
        const panelFileInput = ref(null);
        const encoding = ref("gbk");

        // File panel state
        // Each tab: { name, content, _buffer?, _bomDetected? }
        const fileTabs = reactive([]);
        const activeFileIdx = ref(-1);
        const filePanelWidth = ref(400);
        const isMobile = window.innerWidth < 800
        const sidebarCollapsed = ref(isMobile);
        const filePanelCollapsed = ref(isMobile);
        const isResizing = ref(false);
        let resizeStartX = 0;
        let resizeStartWidth = 400;

        const activeFile = computed(() => {
            if (activeFileIdx.value >= 0 && activeFileIdx.value < fileTabs.length) {
                return fileTabs[activeFileIdx.value];
            }
            return null;
        });

        // Re-decode all buffered files when encoding changes
        function onEncodingChange() {
            for (const tab of fileTabs) {
                if (tab._buffer) {
                    tab.content = decodeBuffer(tab._buffer, encoding.value);
                }
            }
        }

        // File manager API provided to child components
        const fileManager = {
            fileTabs,
            activeFileIdx,
            activeFile,

            /**
             * Add or update a file tab (for generated NC content, no buffer)
             * @param {string} name - filename
             * @param {string} content - file content
             */
            addFileTab(name, content) {
                const existing = fileTabs.findIndex((t) => t.name === name);
                if (existing >= 0) {
                    fileTabs[existing].content = content;
                    // Generated content has no buffer — keep any existing buffer or set null
                    if (!fileTabs[existing]._buffer) {
                        fileTabs[existing]._buffer = null;
                        fileTabs[existing]._bomDetected = null;
                    }
                    activeFileIdx.value = existing;
                } else {
                    fileTabs.push({
                        name,
                        content,
                        _buffer: null,
                        _bomDetected: null,
                    });
                    activeFileIdx.value = fileTabs.length - 1;
                }
            },

            /**
             * Get the currently active file, or null
             */
            getActiveFile() {
                if (
                    activeFileIdx.value >= 0 &&
                    activeFileIdx.value < fileTabs.length
                ) {
                    return {
                        name: fileTabs[activeFileIdx.value].name,
                        content: fileTabs[activeFileIdx.value].content,
                    };
                }
                return null;
            },

            /**
             * Update content of a specific tab
             */
            updateFileTab(index, content) {
                if (index >= 0 && index < fileTabs.length) {
                    fileTabs[index].content = content;
                }
            },
        };

        provide("fileManager", fileManager);

        // Serial connection state — shared with child components
        const serialState = reactive({
            connected: false,
            port: null,
            info: null,
        });
        provide("serialState", serialState);

        function onSerialConnected({ port, info }) {
            serialState.connected = true;
            serialState.port = port;
            serialState.info = info;
        }

        function onSerialDisconnected() {
            serialState.connected = false;
            serialState.port = null;
            serialState.info = null;
        }

        // Resize logic
        function startResize(e) {
            isResizing.value = true;
            resizeStartX = e.clientX;
            resizeStartWidth = filePanelWidth.value;

            const onMouseMove = (ev) => {
                if (!isResizing.value) return;
                const delta = resizeStartX - ev.clientX;
                const newWidth = Math.max(400, resizeStartWidth + delta);
                filePanelWidth.value = newWidth;
            };

            const onMouseUp = () => {
                isResizing.value = false;
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
                document.body.style.cursor = "";
                document.body.style.userSelect = "";
            };

            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
            document.body.style.cursor = "col-resize";
            document.body.style.userSelect = "none";
        }

        function closeFileTab(idx) {
            fileTabs.splice(idx, 1);
            if (fileTabs.length === 0) {
                activeFileIdx.value = -1;
            } else if (activeFileIdx.value >= fileTabs.length) {
                activeFileIdx.value = fileTabs.length - 1;
            }
        }

        function triggerUpload() {
            panelFileInput.value.click();
        }

        async function onPanelFileUpload() {
            const file = panelFileInput.value.files[0];
            if (!file) return;

            try {
                // Read as ArrayBuffer for BOM detection and re-encoding support
                const buffer = await readFileAsArrayBuffer(panelFileInput.value);
                const bom = detectBOM(buffer);

                let text;
                let bomDetected = null;

                if (bom === "utf-8") {
                    // BOM detected: use UTF-8 and strip BOM bytes
                    bomDetected = "UTF-8 (BOM)";
                    text = decodeBuffer(buffer.slice(3), "utf-8");
                } else if (bom === "utf-16le" || bom === "utf-16be") {
                    bomDetected = bom.toUpperCase() + " (BOM)";
                    text = decodeBuffer(buffer.slice(2), bom);
                } else {
                    // No BOM, use current encoding setting
                    text = decodeBuffer(buffer, encoding.value);
                }

                fileManager.addFileTab(file.name, text);

                // Store buffer for re-encoding later, and BOM info
                const tab = fileTabs[activeFileIdx.value];
                if (tab) {
                    tab._buffer = buffer;
                    tab._bomDetected = bomDetected;
                }
            } catch (e) {
                alert("读取文件失败：" + e.message);
                console.error(e);
            }

            // Reset so the same file can be re-uploaded
            panelFileInput.value.value = "";
        }

        function copyActiveFile() {
            const file = fileManager.getActiveFile();
            if (!file) {
                alert("没有可复制的内容");
                return;
            }
            navigator.clipboard.writeText(file.content).then(
                () => {
                    // Brief visual feedback could go here
                },
                (_err) => {
                    // Fallback for older browsers
                    const ta = document.createElement("textarea");
                    ta.value = file.content;
                    ta.style.position = "fixed";
                    ta.style.left = "-9999px";
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand("copy");
                    document.body.removeChild(ta);
                }
            );
        }

        function previewActiveFile() {
            const file = fileManager.getActiveFile();
            if (!file) {
                alert("没有可预览的文件");
                return;
            }
            // Open NC Viewer in new window
            // Note: ncviewer.com loads files client-side; user can paste content there
            window.open("https://ncviewer.com/", "_blank");
        }

        function downloadActiveFile() {
            const file = fileManager.getActiveFile();
            if (!file) {
                alert("没有可下载的文件，请先在面板中选择一个文件");
                return;
            }
            // Use the current encoding when downloading
            downloadTextFile(file.content, file.name);
        }

        return {
            activeTab,
            fileTabs,
            activeFileIdx,
            activeFile,
            filePanelWidth,
            sidebarCollapsed,
            filePanelCollapsed,
            isMobile,
            isResizing,
            fileManager,
            panelFileInput,
            encoding,
            startResize,
            closeFileTab,
            triggerUpload,
            onPanelFileUpload,
            onEncodingChange,
            copyActiveFile,
            previewActiveFile,
            downloadActiveFile,
            onSerialConnected,
            onSerialDisconnected,
        };
    },

    methods: {},
};
</script>
